export const SITES_FETCH_ALL_PENDING = "SITES_FETCH_ALL_PENDING";
export const SITES_FETCH_ALL_FULFILLED = "SITES_FETCH_ALL_FULFILLED";
export const SITES_FETCH_ALL_REJECTED = "SITES_FETCH_ALL_REJECTED";

export const SITES_FETCH_FLIGHT_PLAN_PENDING =
  "SITES_FETCH_FLIGHT_PLAN_PENDING";
export const SITES_FETCH_FLIGHT_PLAN_FULFILLED =
  "SITES_FETCH_FLIGHT_PLAN_FULFILLED";
export const SITES_FETCH_FLIGHT_PLAN_REJECTED =
  "SITES_FETCH_FLIGHT_PLAN_REJECTED";

export const ERROR_INVALID_GEOJSON = "INVALID_GEOJSON";
